export const devPaymentPfmConfig = {
  /**
   * Payment service have different base url, so we need to override it for dev payment
   */
  baseURL: import.meta.env.VITE_PFM_DEV_PAYMENT_BASE_URL,
  /**
   * Need to send request with host consumer token.
   * So we override Authorization header
   */
  headers: {
    Authorization: `Bearer ${import.meta.env.VITE_PFM_DEV_CONSUMER_TOKEN}`,
  },
};
